import { Department } from "@src/types";
import { columnTypes, paginationGridOptions } from "@src/utils/aggrid_utils";
import { ColDef, GetRowIdParams, GridOptions } from "ag-grid-community";

export function getGridOptions(): GridOptions {
  return {
    ...paginationGridOptions,
    getRowId: (params: GetRowIdParams<Department>) => {
      return params.data.departmentId.toString();
    },
    rowHeight: 50,
    domLayout: "autoHeight",
    suppressContextMenu: true,
    headerHeight: 26,
    autoSizeStrategy: {
      type: "fitGridWidth",
    },
    defaultColDef: {
      ...columnTypes.default,
    },
  };
}

export function getColumnDefs(): ColDef<Department>[] {
  return [
    {
      field: "orgName",
      headerName: "Department Name",
      flex: 2,
    },
    {
      field: "orgUnit",
      headerName: "Org Code",
      flex: 1,
    },
    {
      field: "departmentLevel",
      headerName: "Level",
      flex: 1,
    },
  ];
}
